import { useTranslation } from 'react-i18next';
import { ChevronDown } from 'lucide-react';

export function ItemsInSellerQuotesToggle({
  count,
  isShown,
  followsListedItems,
  itemsTableId,
  onToggle,
}: Readonly<{
  count: number;
  isShown: boolean;
  followsListedItems: boolean;
  itemsTableId: string;
  onToggle: () => void;
}>) {
  const { t } = useTranslation('inventory');

  return (
    <p
      className={`flex items-center gap-2 text-sm text-neut-sec ${followsListedItems ? 'mt-3' : ''}`}
      data-testid="buy-list-items-in-seller-quotes"
    >
      {t('inventory.buy_list.items_in_seller_quotes', { count })}
      <span aria-hidden="true">·</span>
      <button
        type="button"
        className="inline-flex items-center gap-1 text-xs font-medium text-prim hover:text-prim-hover"
        aria-expanded={isShown}
        aria-controls={isShown ? itemsTableId : undefined}
        aria-label={t('inventory.buy_list.toggle_items_in_seller_quotes', {
          count,
        })}
        data-testid="buy-list-items-in-seller-quotes-toggle"
        onClick={onToggle}
      >
        {isShown
          ? t('inventory.buy_list.hide_items_in_seller_quotes')
          : t('inventory.buy_list.show_items_in_seller_quotes')}
        <ChevronDown
          size={14}
          aria-hidden="true"
          className={`transition-transform ${isShown ? '' : '-rotate-90'}`}
        />
      </button>
    </p>
  );
}
